import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames/dedupe'

import PanelGroup from 'react-bootstrap/lib/PanelGroup'
import Panel from 'react-bootstrap/lib/Panel'
import HeaderArrow from './HeaderArrow'
import './AccordionPanel.less'

export default class Accordion extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      activeKey: props.activeKey
    }
    this.handleSelect = this.handleSelect.bind(this)
  }
  componentWillReceiveProps (props) {
    this.setState({activeKey: props.activeKey})
  }
  handleSelect (activeKey, event) {
    if (this.props.panels[activeKey] && this.props.panels[activeKey].disabled) {
      return
    }
    if (typeof this.props.onSelect === 'function') {
      this.props.onSelect(activeKey)
    } else if (this.state.activeKey === activeKey) {
      this.setState({activeKey: null})
    } else {
      this.setState({activeKey})
    }

    event.stopPropagation()
  }
  render () {
    const panels = this.props.panels.map((panel, index) => {
      const { className, lightColor, header, disabled, ...panelProperties } = panel
      const classes = classnames(
        'infra-accordion-panel',
        className,
        lightColor
          ? 'panel-light'
          : undefined,
        this.state.activeKey === index
          ? 'infra-accordion-panel-open'
          : 'infra-accordion-panel-closed',
        disabled ? 'panel-disabled' : undefined
      )

      const headerValue = this.props.headerArrow ? <HeaderArrow onClick={this.handleSelect.bind(this, index)}>{header}</HeaderArrow> : header

      return <Panel
        {...panelProperties}
        header={headerValue}
        eventKey={index}
        key={index}
        className={classes}
      >
        {panel.content}
      </Panel>
    })
    return (
      <PanelGroup
        className='infra-accordion infra-component'
        activeKey={this.state.activeKey === null ? -1 : this.state.activeKey}
        onSelect={this.handleSelect}
        accordion
      >
        {panels}
      </PanelGroup>
    )
  }
}

Accordion.propTypes = {
  panels: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string
    ]).isRequired,
    content: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string
    ]).isRequired,
    onSelect: PropTypes.func,
    activeKey: PropTypes.number,
    lightColor: PropTypes.bool,
    disabled: PropTypes.bool
  })).isRequired,
  headerArrow: PropTypes.bool
}

Accordion.defaultProps = {
  activeKey: null,
  lightColor: false,
  headerArrow: false
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Accordion/index.js